import css from 'styled-jsx/css';
import { sansSerif, serif } from 'styles/css-constants';
import { sharedPalette, warmGrays } from 'styles/colors/constants';
import { MQ_MEDIUM, MQ_LARGE, MQ_MIDLARGE } from 'constants/mq';

export default css`
  .ProductTeaserListItem {
    position: relative;
    margin-bottom: 1.25rem;
    border-bottom: 1px solid ${warmGrays[2]};
    padding-bottom: 1.25rem;
    text-decoration: none;
  }

  .ProductTeaserListItem:last-child {
    border-bottom: none;
  }

  .ProductTeaserListItem__body {
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .ProductTeaserListItem__description,
  .ProductTeaserListItem__name,
  .ProductTeaserListItem__retailer {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .ProductTeaserListItem__meta {
    height: 28px;
    min-width: 64px;
    font-size: 12.5px;
    line-height: 1;
    z-index: 1;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ProductTeaserListItem__cake {
    background-color: ${sharedPalette.watermelon};
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 1rem;
  }

  .ProductTeaserListItem__comparisonPrice {
    margin-left: 0.25rem;
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg1);
  }

  .ProductTeaserListItem__counter {
    top: 0;
    left: 0;
    background-color: #fff;
  }

  .ProductTeaserListItem__cta,
  .ProductTeaserListItem__price,
  .ProductTeaserListItem__retailer {
    font-family: ${sansSerif};
  }

  .ProductTeaserListItem__cta {
    margin: 0 auto;
    display: block;
    width: 260px;
    padding: 0.375rem;
    background-color: #000;
    color: #fff;
    font-size: var(--fontScaleNeg1);
    letter-spacing: 0.02em;
    text-align: center;
    text-transform: uppercase;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .ProductTeaserListItem__description {
    font-family: ${serif};
    font-size: var(--fontScale1);
    line-height: 1.5;
  }

  .ProductTeaserListItem__description :global(p) {
    margin-bottom: 1em;
  }

  .ProductTeaserListItem__description :global(a) {
    border-bottom: 1px solid ${sharedPalette.watermelon};
    color: #000;
  }

  .ProductTeaserListItem__image {
    display: block;
    margin-bottom: 1rem;
  }

  .ProductTeaserListItem__name {
    margin-bottom: 0.25rem;
    color: #000;
    font-family: ${serif};
    font-size: var(--fontScale2);
    font-weight: bold;
  }

  .ProductTeaserListItem__name a {
    border-bottom: 1px solid ${sharedPalette.watermelon};
    color: #000;
  }

  .ProductTeaserListItem__price {
    margin-bottom: 1rem;
    color: #000;
    font-size: var(--baseFontSize);
    font-weight: bold;
  }

  .ProductTeaserListItem__retailer {
    margin-bottom: 1rem;
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg1);
    text-transform: uppercase;
  }

  @supports (display: grid) {
    @media screen and ${MQ_MEDIUM} {
      .ProductTeaserListItem__body {
        margin-bottom: 1.25rem;
        display: grid;
        align-items: baseline;
        grid-template-areas:
          'sponsor     sponsor'
          'name        price'
          'retailer    comparison'
          'description description';
        grid-template-columns: 1fr fit-content(25%);
      }

      .ProductTeaserListItem__comparisonPrice {
        grid-area: comparison;
        align-self: start;
        justify-self: end;
        margin-bottom: 0;
        padding-right: 1.5rem;
      }

      .ProductTeaserListItem__meta {
        height: 40px;
        min-width: 86px;
      }

      .ProductTeaserListItem__counter {
        font-size: 17px;
      }

      .ProductTeaserListItem__cake {
        font-size: 14px;
      }

      .ProductTeaserListItem__cta {
        margin: 0;
        display: inline-block;
        width: auto;
        padding: 0.5rem 3.25rem;
      }

      .ProductTeaserListItem__description {
        grid-area: description;
        max-width: none;
        min-width: 0;
      }

      .ProductTeaserListItem__name {
        grid-area: name;
        margin-bottom: 0;
      }

      .ProductTeaserListItem__price {
        grid-area: price;
        justify-self: end;
        margin-bottom: 0;
        padding-right: 1.5rem;
      }

      .ProductTeaserListItem__retailer {
        grid-area: retailer;
        margin-top: 0.375rem;
      }

      .ProductTeaserListItem :global(.Placeholder) {
        max-height: none;
      }
    }

    @media screen and ${MQ_LARGE} {
      .ProductTeaserListItem__comparisonPrice {
        font-size: var(--baseFontSize);
      }

      .ProductTeaserListItem__cta {
        font-size: var(--baseFontSize);
      }

      .ProductTeaserListItem__price {
        font-size: var(--fontScale1);
      }

      .ProductTeaserListItem :global(.Placeholder) {
        max-height: none;
      }
    }

    @media screen and ${MQ_MIDLARGE} {
      .ProductTeaserListItem :global(.Placeholder) {
        max-height: none;
      }
    }
  }
`;
